angular.module('common.directives.focus', [])

    // Focus element on page load
    .directive('focusOnLoad', function ($timeout) {
        return {
            restrict: "AC",
            link: function (scope, element) {
                $timeout(function () {
                    element.focus();
                    element.select();
                });
            }
        };
    })

    // Focus on page load for touch devices
    .directive('focusOnLoadTouch', function ($timeout, device) {
        return {
            restrict: "AC",
            link: function (scope, element) {
                if (device.isTouch()) {
                    $timeout(function () {
                        element.focus();
                        element.select();
                    });
                }
            }
        };
    })

    // Focus on page load for non-touch devices
    .directive('focusOnLoadNotTouch', function ($timeout, device) {
        return {
            restrict: "AC",
            link: function (scope, element) {
                if (!device.isTouch()) {
                    $timeout(function () {
                        element.focus();
                        element.select();
                    });
                }
            }
        };
    })

    .directive('focus', function ($timeout, focusManagementService, device) {
        return {
            restrict: 'A',
            scope: {focus: '='},
            link: function (scope, iElement) {
                var config = scope.focus;
                var element = $(iElement);

                if (_.isUndefined(config)) {
                    config = {index: 0};
                } else if (_.isNumber(config)) {
                    config = {index: config};
                } else if (_.isString(config)) {
                    config = {index: parseInt(config)};
                }

                if (config.touch === true) {
                    if (device.isTouch()) {
                        focusManagementService.registerElement(element, config.index);
                    }
                } else {
                    if (!device.isTouch()) {
                        focusManagementService.registerElement(element, config.index);
                    }
                }

                if (!config.ignoreEnter) {
                    element.keypress(function (e) {
                        var code = (e.keyCode ? e.keyCode : e.which);
                        if (code == 13) { // Enter
                            $timeout(function () {
                                focusManagementService.focusNext(element);
                            });
                            e.preventDefault();
                            return false;
                        }
                    });
                }

                if (config.watch) {
                    if (_.isString(config.watch)) {
                        config.watch = [config.watch];
                    }
                    if (_.isArray(config.watch)) {
                        _.forEach(config.watch, function (watchName) {
                            scope.$watch(watchName, function (newValue, oldValue) {
                                if (!_.isEqual(newValue, oldValue)) {
                                    $timeout(function () {
                                        focusManagementService.setFocus(element);
                                    });
                                }
                            });
                        });
                    }
                }

                if (config.event) {
                    if (_.isString(config.event)) {
                        config.event = [config.event];
                    }
                    if (_.isArray(config.event)) {
                        _.forEach(config.event, function (eventName) {
                            scope.$on(eventName, function () {
                                $timeout(function () {
                                    focusManagementService.setFocus(element);
                                });
                            });
                        });
                    }
                }

                scope.$on('$destroy', function () {
                    focusManagementService.unregisterElement(element);
                });
            }
        };
    })

    .service('focusManagementService', function ($timeout) {
        // Collection of elements for focus management
        var elements = [];
        var defaultTimeout = 50;

        /**
         * Register element for focus management
         */
        function registerElement(element, index) {
            elements.push({
                element: element,
                index: index
            });
            doFocusFirstElement();
        }

        /**
         * Unregister element from focus management queue
         */
        function unregisterElement(element) {
            elements = _.reject(elements, function (e) {
                return $(e.element).is(element);
            });
            //doFocusFirstElement();
        }

        function getVisibleElements() {
            elements = _.sortBy(elements, 'index');

            return _.filter(elements, function (e) {
                return e && e.index >= 0 && e.element && e.element[0] && $.contains(document.documentElement, e.element[0]);
            });
        }

        function doFocusFirstElement() {
            $timeout(function () {
                    var visibleElements = getVisibleElements();

                    if (visibleElements[0]) {
                        var el = $(visibleElements[0].element);
                        if (!el || !el[0]) {
                            return;
                        }
                        if ($.contains(document.documentElement, el[0])) {
                            (function (e) {
                                $timeout(function () {
                                    e.focus();
                                    e.select();
                                });
                            })(el);
                        } else {
                            doFocusFirstElement();
                        }
                    }
                },
                defaultTimeout);
        }

        function doFocusNextElement(element) {
            $timeout(function () {
                if (!element || !element[0]) {
                    return;
                }

                var visibleElements = getVisibleElements();
                for (var i = 0; i < visibleElements.length; i++) {
                    if ($(visibleElements[i].element).is(element)) {
                        if (visibleElements[i + 1]) {
                            var toFocus = $(visibleElements[i + 1].element);
                            if (!toFocus[0]) {
                                return;
                            }
                            if ($.contains(document.documentElement, toFocus[0])) {
                                (function (e) {
                                    $timeout(function () {
                                        e.focus();
                                        e.select();
                                    });
                                })(toFocus);
                                return;
                            } else {
                                doFocusNextElement(element);
                            }
                        }
                        return;
                    }
                }
                doFocusFirstElement();
            }, defaultTimeout);
        }

        function doFocusElement(element) {
            $timeout(function () {
                if (!element || !element[0]) {
                    return;
                }

                var visibleElements = getVisibleElements();
                for (var i = 0; i < visibleElements.length; i++) {
                    if ($(visibleElements[i].element).is(element)) {
                        if (visibleElements[i + 1]) {
                            var toFocus = visibleElements[i].element;
                            if (!toFocus[0]) {
                                return;
                            }
                            if ($.contains(document.documentElement, toFocus[0])) {
                                (function (e) {
                                    $timeout(function () {
                                        e.focus();
                                        e.select();
                                    });
                                })(toFocus);
                                return;
                            } else {
                                doFocusElement(element);
                            }
                        }
                        return;
                    }
                }
            }, defaultTimeout);
        }

        /**
         * Set up focus to first element in queue
         */
        function setFocus(element) {
            if (element) {
                doFocusElement(element);
            } else {
                doFocusFirstElement();
            }
        }

        /**
         * Set up focus to next element in queue
         * @param element
         */
        function focusNext(element) {
            doFocusNextElement(element);
        }

        return {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            setFocus: setFocus,
            focusNext: focusNext
        };
    })
;
